import {tns} from 'tiny-slider/src/tiny-slider';

export default (() => {
    $('.images-slider').each(function() {
        tns({
            container: $(this)[0],
            items: 1,
            autoplay: false,
            autoplayButtonOutput: false,
            lazyload: false,
            speed: 2000,
            touch: true,
            controls: true,
            controlsContainer: $(this).find('controls')[0],
            controlsText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
            nav: false,
        });
    })
});



// WEBPACK FOOTER //
// ./scripts/components/images-slider.js